import moment from 'moment';
import React, { useContext, useEffect, useState } from 'react';
import { getInvoiceList } from '../../../Actions/InvoiceActs';
import { GlobalStore } from '../../../StateStores';
import { toast } from 'react-toastify';
import BreadCrumb from '../../Common/BreadCrumb';
import { Button, Card, CardBody, CardHeader, Col, Row, Spinner, Table } from 'reactstrap';
import DateFilter from '../../Common/DateFilter';

const PaymentList = ()=>{
    const [modal, setModal] = useState(false);
    const [invoices, setInvoices] = useState([]);
    const [startDate, setStartDate] = useState(moment());
    const [endDate, setEndDate] = useState(moment());
    const [selectedInvoice, setSelectedInvoice] = useState({});

    const {InvoiceDispatch,InvoiceState:{
        getInvoices:{error,loading,data},
    }} = useContext(GlobalStore);

    const loadInvoices = async ()=>{
        try {
            const response = await getInvoiceList({
                payment:'PAID',
                fromdate: startDate?.format('YYYY-MM-DD'),
                todate: endDate?.format('YYYY-MM-DD')
            })(InvoiceDispatch)
            if(response.status){
                setInvoices(response.data)
            }
        } catch (error) {
            toast.error(error.message)
        }
    }


    useEffect(()=>{
        loadInvoices();
    },[startDate, endDate])

    const togOpenModal = ()=>{
        setModal(!modal);
    }

    const generateConrollNumber = (transaction)=>{
        togOpenModal();
        setSelectedInvoice(transaction)
    }

    return(
        <React.Fragment>
            <div className='mt-5'>
                <BreadCrumb title="List" pageTitle="Payment"/>
                <Card className='shadow-sm'>
                    <CardHeader tag="div">
                        <Row>
                            <Col>
                                <DateFilter 
                                    startDate={startDate}
                                    endDate={endDate}
                                    onDatesChange={({ startDate, endDate }) => {
                                        setStartDate(startDate);
                                        setEndDate(endDate);
                                    }}
                                />
                            </Col>
                            <Col>
                                {/* <Button><span className='ri-search-line'></span> Filter</Button>  */}
                                <Button onClick={loadInvoices} className='ms-1'><span className='ri-refresh-line'></span> Refresh</Button></Col>
                            <Col></Col>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        <Table bordered size="sm" className='caption-top'>
                            <caption>
                                {loading && <Spinner size="sm"/>}
                            </caption>
                            <thead className="bg-light">
                                <tr>
                                    <th>#</th>
                                    <th>Transaction#</th>
                                    <th>Owner</th>
                                    <th>Reg number</th>
                                    <th>Vehicle</th>
                                    <th className='text-center'>Control Number</th>
                                    <th className='text-center'>Amount</th>
                                    <th className='text-center'>Payment Channel</th>
                                    <th className='text-center'>Payment Receipt</th>
                                    <th className='text-center'>Paid Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(invoices || []).map((invoice,index)=>(
                                    <tr>
                                        <td>{++index}</td>
                                        <td>{invoice?.trans_code}</td>
                                        <td>{invoice?.customer_name}</td>
                                        <td>{invoice?.registration_number}</td>
                                        <td>{invoice?.vehicle}</td>
                                        <td><span className='text-primary'>{invoice?.trans_control_no}</span></td>
                                        <td>{invoice?.trans_amount}</td>
                                        <td>{invoice?.trans_pay_channel}</td>
                                        <td><span className='text-primary'>{invoice?.trans_pay_receipt}</span></td>
                                        <td>{moment(invoice?.trans_pay_created_at).format('YYYY-MM-DD')}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </CardBody>
                </Card>
            </div>
        </React.Fragment>
    )
}

export default PaymentList;